/*
 * Landing Page Tracker
 * ------------------------------------------------------------
 * Whenever a customer visits one of the page handles listed in
 * LANDING_PAGE_HANDLES below, this stamps the cart with note
 * attributes (landing page, URL, referrer, UTM params, timestamp).
 * Those attributes ride along into checkout and show up on the
 * order under "Additional details" in the Shopify admin.
 *
 * A Shopify Flow ("Tag orders from tracked landing pages") reads the
 * "Landing Page" attribute on order_created and tags the order
 * accordingly — it doesn't need its own copy of this list, so adding
 * or removing a handle here is the only change needed to track (or
 * stop tracking) a page.
 *
 * Last-touch model: visiting a tracked landing page overwrites any
 * previous attribution stored from an earlier visit in this browser.
 *
 * LANDING_PAGE_HANDLES below is every currently-published page on
 * hpnsupplements.com that isn't a generic site page (about, policies,
 * rewards, etc). Add or remove a handle here to track (or stop
 * tracking) a page — no other change needed.
 * ------------------------------------------------------------
 */
(function () {
  var LANDING_PAGE_HANDLES = [
    'nad3-lowers-ldl-cholesterol-triglycerides-clinical-human-trial',
    'clark-bartram',
    'nick-urankar',
    'dr-michael-setareh',
    't5-cbx-video',
    'nad3-shop-now-page',
    'frank-medrano',
    'nad3-5x',
    'nad3-cellular-health',
    'nad3-dr-michael-setareh',
    'nad3-clark-bartram',
    'nad3-nick-urankar',
    'nad3-frank-medrano',
    'think-its-too-late-to-build-muscle',
    'dont-buy-another-nad-booster',
    'dr-michael-setareh-nad3',
    'active-ingredients-landing-page',
    'best-nad-booster-of-2024',
    'hollywoods-anti-aging-breakthrough',
    'la-mejor-nad-2025',
    'active-ingredients-page',
    'dr-michael-setareh-nad3-review-3',
    'dr-michael-setareh-nad3-review',
    'hidden-cause-of-ed',
    'cardio-health',
    'el-mejor-nad-2025',
    'dr-michael-setareh-nad3-resena',
    'clark-bartram-thank-you-t5',
    'frank-medrano-bundle-thank-you',
    'nick-urankar-bundle-thank-you',
    'clark-bartram-bundle-thank-you',
    'nad3-dr-michael-setareh-1',
    'nad3-dr-michael-setareh-resena',
    'nad3-dr-michael-setareh-resena-afl',
    'nad3-dr-michael-setareh-afl',
    'la-mejor-nad-2025-afl',
    'best-nad-booster-of-2025-afl',
    'dont-buy-another-nad-booster-afl',
    'estan-manipulando-tu-comida-y-es-un-gran-problema',
    'your-food-is-being-engineered-and-its-a-problem',
    'nad3-dr-michael-setareh-choice-4wm',
    'nad3-la-elecci-n-del-dr-michael-setareh-4wm',
    'dont-buy-another-nad-booster-4wm',
    'best-nad-booster-of-2025-4wm',
    'la-mejor-nad-2025-4wm',
    'try-this-hack-guaranteed-to-work',
    'dr-setareh-nad3-review',
    '5-signs-your-nad-levels-are-rising',
    'dr-setareh-review-nad3',
    '5-tips-to-sky-rocket-your-gains',
    'dr-nad3-review',
    'best-nad-booster-of-2025-afl-4y',
    'best-nad-booster-of-2025-4rl',
    'shop-form-3-0-new-frequency-buttons-ocu-popup',
    'shop-form-3-0-no-compare-price-on-otp-button-ocu-popup',
    '5-ways-raising-nad-can-transform-your-health',
    'the-cholesterol-conspiracy',
    'doctor-nad3-review',
    'seed-oils-the-health-debate-we-cant-ignore',
    'nad3-review-doctor-setareh',
    'the-american-cholesterol-conspiracy',
    'metabolic-theory-of-cancer',
    'supplement-checklist-guide',
    'dirty-oceans-dirty-fish-oil',
    'dr-setareh-nad3-resena',
    'doctor-setareh-nad3',
    'original-fountain-of-youth',
    '5-reasons-boosting-testosterone-will-improve-your-health',
    'rest-isnt-weakness',
    'telemore-and-healthy-aging',
    '5-foods-that-burn-more-fat-than-ozempic',
    'morning-vs-evening-workouts',
    'nad3-doctor-setareh-review',
    'optimized-metabolism-is-more-valuable-than-ozempic',
    'gettings-your-steps-is-just-the-beginning',
    'gettings-your-steps-is-just-the-beginning-v2',
    'two-minutes-can-double-your-gain',
    'sleep-is-the-1-longevity-tool',
    'secrets-to-cellular-health',
    'tu-nad-no-sirve',
    'demmi-den-landing-page-not-shogun',
    'doctor-setareh-review-nad3',
    'vitamind3-longevity-study',
    'vitamind-fat-loss-benefits',
    'pa7-unleash-your-natural-potential',
    'ozempic-vs-optimization',
    'nad3-denni',
    's9-v2',
    'nad3-so1',
    'nad3-v2',
    'pa7',
    '5-razones-pa7-aumenta-musculo',
    'is-your-nad-supplement-the-real-deal',
    'sub-is-your-nad-supplement-the-real-deal',
    'pa7-mediator-mtor-elevation',
    'home-fs',
    'dangers-of-synthetic-nad',
    'nad3-vs-others',
    't5-so1',
    'age-slowing-your-recovery',
    'longevity-supplement-reporting-hair-growth',
    'faster-hair-loss-results',
    'dr-nad3-review-oc2',
    'truth-about-low-t',
    'nad3-anti-aging',
    'the-mirror-doesnt-lie',
    'luce-mas-joven',
    'anti-aging-breakthrough',
    'revolucionario-en-antienvejecimiento',
    'el-espejo-no-miente',
    'm6-end-of-summer-sale',
    'best-anti-aging-solution',
    'faster-hair-growth',
    'home-v2',
    'nad3-hair',
    'home-v3',
    'nad3-anti-aging-woman',
    'nad3-nh',
    'pa7-nh',
    'nad3-2-month-supply-nh',
    't5-t-booster-nh',
    'm6-metabolism-optimization-nh',
    's9-nh',
    'c2-nh',
    'n4-icelandic-omega-3-fish-oil-nh',
    'nad3x-survey',
    'all-productsp-nh',
    '5-aging-myths',
    'h-news-featuring-nad3',
    'h-news',
    'home-v2-1',
    'the-best-nad-you-can-buy',
    'best-natural-anti-aging-solution',
    'the-divine-design-inside-you',
    'supercharge-your-hair-loss-meds',
    'h-news-featuring-nad3-2',
    'the-best-nad-you-can-buy-b2g1',
    '10-reason-nad3',
    'longevity-expert-3-nad',
    'the-divine-design-inside-you-video',
    'nad3-faster-hair-growth-dt',
    'quiz',
    'nad3-antiaging-da',
    'nad3-antiaging-db',
    'nad3-vip-da',
    'nad3-vip-db',
    'nad3-faster-hair-growth-dt-vip',
    'nad3-antiaging-da-sub',
    'heart-health-month',
    'nad3-antiaging-da-sub-vid',
    'nad3-vip-video',
    'nad3-starter-kit',
    'pa7-starter-kit',
    'pa7-clinical-data',
    'pa7-secure-order',
    'nad3-starter-kit-sp',
    'essentials-on-the-go',
    'nad3-starter-kit-sp-v2',
    'nad3-starter-kit-v2',
    'nad3-extra-strength',
    'garmin-vivoactive-giveaway'
  ];

  var STORAGE_KEY = 'lp_landing_attribution';
  var SESSION_SYNCED_KEY = 'lp_landing_synced';

  function getUtmParams() {
    var params = new URLSearchParams(window.location.search);
    var utm = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(function (key) {
      var val = params.get(key);
      if (val) utm[key] = val;
    });
    return utm;
  }

  function currentPageHandle() {
    var body = document.body;
    return body ? body.getAttribute('data-page-handle') || '' : '';
  }

  function buildAttributionRecord(handle) {
    return {
      handle: handle,
      url: window.location.href,
      referrer: document.referrer || '',
      utm: getUtmParams(),
      timestamp: new Date().toISOString()
    };
  }

  function readStored() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeStored(record) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(record));
    } catch (e) {}
  }

  function syncCartAttributes(record) {
    var attributes = {
      'Landing Page': record.handle,
      'Landing URL': record.url,
      'Landing Referrer': record.referrer,
      'Landing Visited At': record.timestamp
    };
    Object.keys(record.utm || {}).forEach(function (key) {
      attributes['Landing ' + key] = record.utm[key];
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).then(function () {
      try { window.sessionStorage.setItem(SESSION_SYNCED_KEY, '1'); } catch (e) {}
    }).catch(function () {});
  }

  function init() {
    var handle = currentPageHandle();
    var isLandingPage = handle && LANDING_PAGE_HANDLES.indexOf(handle) !== -1;

    if (isLandingPage) {
      var record = buildAttributionRecord(handle);
      writeStored(record);
      syncCartAttributes(record);
      return;
    }

    // Not a tracked landing page this time — make sure any attribution
    // captured earlier in this browser still rides along at least once
    // per session, in case the cart was recreated since that visit.
    var alreadySynced = false;
    try { alreadySynced = window.sessionStorage.getItem(SESSION_SYNCED_KEY) === '1'; } catch (e) {}
    if (alreadySynced) return;

    var stored = readStored();
    if (stored) syncCartAttributes(stored);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
